var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.738,
    height: 19.665,
    viewBox: "0 0 24.738 19.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -52.499)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 52.499)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.582,123.781a.966.966,0,0,0-1.228-.115c-1.446.986-8.7,5.941-9.478,6.721a2.9,2.9,0,0,0,4.1,4.1c.779-.779,5.735-8.032,6.721-9.478A.967.967,0,0,0,207.582,123.781Zm-7.972,9.339a.966.966,0,0,1-1.367-1.366c.3-.3,2.362-1.768,4.9-3.529C201.377,130.758,199.909,132.817,199.609,133.12Z",
    transform: "translate(-186.557 -120.068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.456,69.362l-1.193.582a10.388,10.388,0,0,1-.651-8.781l1.367.656a.966.966,0,1,0,.836-1.743l-1.35-.647A10.45,10.45,0,0,1,11.4,54.476v1.453a.966.966,0,0,0,1.933,0V54.475a10.316,10.316,0,0,1,3.323.875.966.966,0,1,0,.8-1.761A12.359,12.359,0,0,0,2.1,71.734a.966.966,0,0,0,1.227.331L5.3,71.1a.966.966,0,1,0-.847-1.737Z",
    transform: "translate(0 -52.499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.8,192.063a.966.966,0,1,0-1.761.8,10.4,10.4,0,0,1-.416,9.373l-1.245-.593a.966.966,0,0,0-.831,1.745l2.029.966a.966.966,0,0,0,1.219-.335,12.339,12.339,0,0,0,1.005-11.951Z",
    transform: "translate(-371.152 -184.778)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/Meter.d15bab30.svg";
export { ForwardRef as ReactComponent };